export const isValidMobile = (mobile) => {
  const regex = (/^[0-9]{10}$/);
  return regex.test(mobile);
}

export const isPositiveInteger = (value) => {
  const regex = (/^[0-9]+$/);
  return regex.test(value);
}

export const isValidEmail = (email) => {
  const regex = (/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/);
  return regex.test(email);
}

export const isValidPincode = (pincode) => {
  const regex = (/^[0-9]{6}$/);
  return regex.test(pincode);
}

export const isValidPassword = (password) => {
  return password && password.length >= 6;
}